// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ICardHolderWithDependentDto,
  IGetWalletDataResponse,
  IPushProvisionEmailVerificationRequest,
  IPushProvisionRequest,
  IPushProvisionResponse,
} from '../models/index';
import {
    ICardHolderWithDependentDtoFromJSON,
    ICardHolderWithDependentDtoToJSON,
    IGetWalletDataResponseFromJSON,
    IGetWalletDataResponseToJSON,
    IPushProvisionEmailVerificationRequestFromJSON,
    IPushProvisionEmailVerificationRequestToJSON,
    IPushProvisionRequestFromJSON,
    IPushProvisionRequestToJSON,
    IPushProvisionResponseFromJSON,
    IPushProvisionResponseToJSON,
} from '../models/index';

export interface GetCardHoldersByEmployeeIdRequest {
    employeeId: number;
    dependentId?: number;
}

export interface GetCardWalletByCardIdRequest {
    cardId: number;
    userAgentSystem: GetCardWalletByCardIdUserAgentSystemEnum;
    correlationId?: string;
}

export interface PushProvisionRequest {
    cardId: number;
    iPushProvisionRequest: IPushProvisionRequest;
}

export interface VerifyEmailAndUpdateRoleRequest {
    iPushProvisionEmailVerificationRequest: IPushProvisionEmailVerificationRequest;
}

/**
 * ApiAggregatorFinanceApi - interface
 * 
 * @export
 * @interface ApiAggregatorFinanceApiInterface
 */
export interface ApiAggregatorFinanceApiInterface {
    /**
     * 
     * @summary Get card holder
     * @param {number} employeeId 
     * @param {number} [dependentId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorFinanceApiInterface
     */
    getCardHoldersByEmployeeIdRaw(requestParameters: GetCardHoldersByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICardHolderWithDependentDto>>;

    /**
     * Get card holder
     */
    getCardHoldersByEmployeeId(requestParameters: GetCardHoldersByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICardHolderWithDependentDto>;

    /**
     * 
     * @summary Get card wallet by card id
     * @param {number} cardId 
     * @param {'WINDOWS' | 'MAC' | 'UNIX' | 'ANDROID' | 'IOS'} userAgentSystem 
     * @param {string} [correlationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorFinanceApiInterface
     */
    getCardWalletByCardIdRaw(requestParameters: GetCardWalletByCardIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IGetWalletDataResponse>>;

    /**
     * Get card wallet by card id
     */
    getCardWalletByCardId(requestParameters: GetCardWalletByCardIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IGetWalletDataResponse>;

    /**
     * 
     * @summary Push provision by card id
     * @param {number} cardId 
     * @param {IPushProvisionRequest} iPushProvisionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorFinanceApiInterface
     */
    pushProvisionRaw(requestParameters: PushProvisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPushProvisionResponse>>;

    /**
     * Push provision by card id
     */
    pushProvision(requestParameters: PushProvisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPushProvisionResponse>;

    /**
     * 
     * @summary Verify email and update role
     * @param {IPushProvisionEmailVerificationRequest} iPushProvisionEmailVerificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiAggregatorFinanceApiInterface
     */
    verifyEmailAndUpdateRoleRaw(requestParameters: VerifyEmailAndUpdateRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPushProvisionResponse>>;

    /**
     * Verify email and update role
     */
    verifyEmailAndUpdateRole(requestParameters: VerifyEmailAndUpdateRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPushProvisionResponse>;

}

/**
 * 
 */
export class ApiAggregatorFinanceApi extends runtime.BaseAPI implements ApiAggregatorFinanceApiInterface {

    /**
     * Get card holder
     */
    async getCardHoldersByEmployeeIdRaw(requestParameters: GetCardHoldersByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICardHolderWithDependentDto>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling getCardHoldersByEmployeeId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['dependentId'] != null) {
            queryParameters['dependent_id'] = requestParameters['dependentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/card-holders`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICardHolderWithDependentDtoFromJSON(jsonValue));
    }

    /**
     * Get card holder
     */
    async getCardHoldersByEmployeeId(requestParameters: GetCardHoldersByEmployeeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICardHolderWithDependentDto> {
        const response = await this.getCardHoldersByEmployeeIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get card wallet by card id
     */
    async getCardWalletByCardIdRaw(requestParameters: GetCardWalletByCardIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IGetWalletDataResponse>> {
        if (requestParameters['cardId'] == null) {
            throw new runtime.RequiredError(
                'cardId',
                'Required parameter "cardId" was null or undefined when calling getCardWalletByCardId().'
            );
        }

        if (requestParameters['userAgentSystem'] == null) {
            throw new runtime.RequiredError(
                'userAgentSystem',
                'Required parameter "userAgentSystem" was null or undefined when calling getCardWalletByCardId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['correlationId'] != null) {
            queryParameters['correlation_id'] = requestParameters['correlationId'];
        }

        if (requestParameters['userAgentSystem'] != null) {
            queryParameters['user_agent_system'] = requestParameters['userAgentSystem'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/card/{card_id}/wallets`;
        urlPath = urlPath.replace(`{${"card_id"}}`, encodeURIComponent(String(requestParameters['cardId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IGetWalletDataResponseFromJSON(jsonValue));
    }

    /**
     * Get card wallet by card id
     */
    async getCardWalletByCardId(requestParameters: GetCardWalletByCardIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IGetWalletDataResponse> {
        const response = await this.getCardWalletByCardIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Push provision by card id
     */
    async pushProvisionRaw(requestParameters: PushProvisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPushProvisionResponse>> {
        if (requestParameters['cardId'] == null) {
            throw new runtime.RequiredError(
                'cardId',
                'Required parameter "cardId" was null or undefined when calling pushProvision().'
            );
        }

        if (requestParameters['iPushProvisionRequest'] == null) {
            throw new runtime.RequiredError(
                'iPushProvisionRequest',
                'Required parameter "iPushProvisionRequest" was null or undefined when calling pushProvision().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/card/{card_id}/provision`;
        urlPath = urlPath.replace(`{${"card_id"}}`, encodeURIComponent(String(requestParameters['cardId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IPushProvisionRequestToJSON(requestParameters['iPushProvisionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPushProvisionResponseFromJSON(jsonValue));
    }

    /**
     * Push provision by card id
     */
    async pushProvision(requestParameters: PushProvisionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPushProvisionResponse> {
        const response = await this.pushProvisionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verify email and update role
     */
    async verifyEmailAndUpdateRoleRaw(requestParameters: VerifyEmailAndUpdateRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPushProvisionResponse>> {
        if (requestParameters['iPushProvisionEmailVerificationRequest'] == null) {
            throw new runtime.RequiredError(
                'iPushProvisionEmailVerificationRequest',
                'Required parameter "iPushProvisionEmailVerificationRequest" was null or undefined when calling verifyEmailAndUpdateRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/push-provision/email-validation`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IPushProvisionEmailVerificationRequestToJSON(requestParameters['iPushProvisionEmailVerificationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPushProvisionResponseFromJSON(jsonValue));
    }

    /**
     * Verify email and update role
     */
    async verifyEmailAndUpdateRole(requestParameters: VerifyEmailAndUpdateRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPushProvisionResponse> {
        const response = await this.verifyEmailAndUpdateRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
  * @export
  * @enum {string}
  */
export enum GetCardWalletByCardIdUserAgentSystemEnum {
    WINDOWS = 'WINDOWS',
    MAC = 'MAC',
    UNIX = 'UNIX',
    ANDROID = 'ANDROID',
    IOS = 'IOS'
}
